import React, { useCallback, useEffect, useState } from 'react';
import propTypes from 'prop-types';

import { SKINS } from '~/Config/Products';
import { PORTRAIT_IMAGE } from '~/Redux/Modules/Admin/Skins';

import Product from '~/Components/Global/Stripe/Product';
import Button from '~/Components/Global/Form/Button';
import { findImagePath } from '~/Context/Global';
import { TABLET_WIDTH } from '~/Redux/Constants';

import './SelectedCover.scss';
import Spinner from '~/Components/Global/Loading/Spinner';

const SelectedCover = props => {
  const { currentCover, isFetching, userOptions, updateSkin } = props;
  const [isLoaded, setLoaded] = useState(false);

  const preloadImage = useCallback(() => {
    console.log('Selected Cover', 'initializing preload image', currentCover);
    if (!currentCover) {
      return;
    }
    let preloader = new Image();
    preloader.onload = () => {
      setLoaded(true);
      console.log('Selected Cover', 'loaded current cover', currentCover);
    };
    preloader.src = findImagePath(
      currentCover.images,
      PORTRAIT_IMAGE,
      window.innerWidth <= TABLET_WIDTH
    );
    console.log('Selected Cover', 'found image path');
  }, [setLoaded, currentCover]);

  useEffect(() => {
    console.log('Selected Cover', 'useEffect', isLoaded, currentCover);
    if (isLoaded) {
      return;
    }
    if (!currentCover) {
      return;
    }
    preloadImage();
  }, [isLoaded, currentCover, preloadImage]);

  if (!isLoaded) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }
  return (
    <div className="current-cover">
      {currentCover && [
        <Product
          key="a"
          product={currentCover.product}
          description={currentCover.name}
          type={SKINS}
        />,
        currentCover.product.purchased &&
          (currentCover.id === userOptions.skin_id ? (
            <Button
              key="b"
              text="Default"
              disabled
              className="margin-bottom btn btn-default pill center"
            />
          ) : (
            <Button
              key="b"
              type="submit"
              text="Set as Default"
              actionText="Setting"
              isFetching={isFetching}
              disabled={isFetching}
              className="margin-bottom btn btn-default pill center"
              onClick={() => updateSkin(userOptions.id, currentCover.id, currentCover)}
            />
          )),
        <div key="c" className="mobile-spacer" />,
      ]}
      <img
        src={findImagePath(currentCover.images, PORTRAIT_IMAGE, window.innerWidth <= TABLET_WIDTH)}
        alt=""
      />
      <h4>{currentCover.name}</h4>
    </div>
  );
};

SelectedCover.propTypes = {
  currentCover: propTypes.object,
  userOptions: propTypes.object,
  updateSkin: propTypes.func,
  isFetching: propTypes.bool,
};

export default SelectedCover;
